import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent'

import { idlFactory as idl } from '@idls/icrc21/icrc21.did'
import type { _SERVICE as ICRC21Service } from '@idls/icrc21/icrc21.did'
import getAgent from '@plug-core/utils/getAgent'

export const fetchCanisterConsentMessage = async (
  canisterId: string,
  method: string,
  arg: ArrayBuffer
) => {
  const agent = getAgent()
  const actor = Actor.createActor(idl, {
    canisterId,
    agent,
  }) as ActorSubclass<ICRC21Service>

  const concent = await actor.icrc21_canister_call_consent_message({
    arg: new Uint8Array(arg),
    method,
    user_preferences: {
      metadata: {
        language: 'en',
      },
      device_spec: [],
    },
  })

  if ('Ok' in concent) {
    if ('GenericDisplayMessage' in concent.Ok.consent_message) {
      return concent.Ok.consent_message.GenericDisplayMessage
    } else {
      return Promise.reject('Missing message')
    }
  }

  return Promise.reject('Missing message')
}
